/**
 * The bulk price (per m3) typed on the offer form as the value to send: blank or not a finite number means the
 * offer is not sold in bulk (null, never 0); 0 is a valid price.
 */
export function toBulkPrice(value: unknown): number | null {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === 'string' && value.trim() === '') {
    return null;
  }
  const number = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(number) ? number : null;
}
